import { Button, Text } from '@ebh/capsule';
import { flex, gap, padding } from '@ebh/capsule/theme';
import { handleLogout } from '../utils/logout';

interface PermissionsErrorScreenProps {
  isRetryFailed: boolean;
  onRetry: () => void;
}

const PermissionsErrorScreen = ({
  isRetryFailed,
  onRetry,
}: PermissionsErrorScreenProps) => {

  if (isRetryFailed) {
    return (
      <div
        css={[
          flex('center', 'column'),
          padding(3),
          gap(3),
          { minHeight: '100vh' },
        ]}
      >
        <Text variant="header-4">
          Unable to load your permissions
        </Text>

        <Text variant="sub-heading-1" color="gray-500">
          We’re still unable to load your permissions. Please log in again to
          continue.
        </Text>

        <div css={[flex('row'), gap(4)]}>
          <Button
            variant="primary"
            onClick={handleLogout}
            css={[{ cursor: 'pointer' }]}
          >
            Log in again
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      css={[
        flex('center', 'column'),
        padding(3),
        gap(3),
        { minHeight: '100vh' },
      ]}
    >
      <Text variant="header-4">
        Something went wrong
      </Text>

      <Text variant="sub-heading-1" color="gray-500">
        We’re unable to load your permissions. Please try again.
      </Text>

      <div css={[flex('row'), gap(4)]}>
        <Button
          variant="primary"
          onClick={onRetry}
          css={[{ cursor: 'pointer' }]}
        >
          Retry
        </Button>
      </div>
    </div>
  );
};

export default PermissionsErrorScreen;
